// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms{overflow-y:scroll;height:300px;width:100%;border:1px solid #ddd;padding:10px}.TCModal .ant-legacy-form-item{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
